import { AuthConfig } from 'angular-oauth2-oidc';
import { auth0ClientId, environment, organizationValue,   authRefreshTokenTimeoutFactor,
} from '../../environments/environment';
import { auth0Issuer } from '@awin/shared/auth0-helper';

const providerScopes =
  'provider:accounts:writeLinkBuilder ' +
  'provider:accounts:cc:accountProfile:read ' +
  'provider:accounts:cc:communications:read ' +
  'provider:accounts:cc:communications:write ' +
  'provider:accounts:cc:messages:read ' +
  'provider:accounts:cc:preferences:read ' +
  'provider:accounts:cc:messages:write ' +
  'provider:accounts:cc:preferences:write ' +
  'provider:accounts:cc:publisherSelector:read';

export const auth0authConfig: AuthConfig = {
  issuer: auth0Issuer[environment.name],
  clientId: auth0ClientId,

  redirectUri: organizationValue ? `https://id.${organizationValue}.awin.com/auth0-redirect/communication-centre/en/awin/oidc` : window.origin + '/communication-centre/en/awin/oidc',
  scope: 'openid offline_access user ' + providerScopes,
  responseType: 'code',
  customQueryParams: {
    audience: 'https://awin.com',
    ...(organizationValue ? { organization: organizationValue } : {}),
    // organization parameter is not needed for staging and production
  },
  logoutUrl: window.origin + '/login',
  showDebugInformation: true,
  timeoutFactor: authRefreshTokenTimeoutFactor,
};
